import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { translate } from 'react-i18next';

const Info = ({
  t, tReady, shape, values, ...rest
}) => (
  <Form {...rest}>
    <Fragment>
      {Array.from(shape).map(([key, shapeInfo]) => {
        const info = {
          ...shapeInfo,
          label: t(shapeInfo.label),
          placeholder: t(shapeInfo.placeholder),
        };
        const value = values[key];
        return <Form.Field key={key} label={info.label} control={() => <span>{value}</span>} />;
      })}
    </Fragment>
  </Form>
);

Info.propTypes = {
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool.isRequired,
  shape: PropTypes.shape({}).isRequired,
  values: PropTypes.shape({}).isRequired,
};

export default translate()(Info);



// WEBPACK FOOTER //
// ./src/components/reusable/Info.js